import styled from 'styled-components';


export const Headi = styled.div`
background-color: #3e4040 ;
height: 9vw; 
margin-top: 0vw;
padding: 3vw;

@media only screen and (max-width:750px){
    height: 25vw;
}
`
export const Hdng = styled.h1`
color:  #bacccc;
border: ;
margin-top: 2.5vw;
display: flex;
justify-content: center;
`

export const S = styled.span`
color: #30c9c6;
`